module.exports = __webpack_public_path__ + "55268a03eb3b36568013ced82cd0b710.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/introduction_text.svg
 ** module id = 256
 ** module chunks = 0
 **/